import React from 'react';

import styles from './Select.Footer.module.scss';

export const SelectFooter: React.FunctionComponent = (props) => <div className={styles.footer}>{props.children}</div>;

SelectFooter.displayName = 'Select.Footer';

export function isSelectFooter(element: React.FunctionComponentElement<any>): boolean {
  return element && element.type.displayName === SelectFooter.displayName;
}
